import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";
import {
  MeetingScheduler,
  UpdateMeetingSchedulerPayload,
} from "../../types/Types";

export function useUpdateMeetingScheduler() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      payload,
    }: {
      id: number;
      payload: UpdateMeetingSchedulerPayload;
    }) => {
      const res = await axiosInstance.put<MeetingScheduler>(
        getAPIURL(`/MeetingScheduler/${id}`),
        payload
      );
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["meeting-schedulers"] });
    },
  });
}

export function usePlayMeetingScheduler() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: number) => {
      const res = await axiosInstance.post<MeetingScheduler>(
        getAPIURL(`/MeetingScheduler/${id}/Play`)
      );
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["meeting-schedulers"] });
    },
  });
}

export function usePauseMeetingScheduler() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: number) => {
      const res = await axiosInstance.post<MeetingScheduler>(
        getAPIURL(`/MeetingScheduler/${id}/Pause`)
      );
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["meeting-schedulers"] });
    },
  });
}
